import type { SessionLog } from "./types";

/** 本地时区的 YYYY-MM-DD */
export function isoDay(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

/** 从起始日往回数连续有记录的天数 */
function countBackward(days: Set<string>, startIso: string): number {
  let streak = 0;
  const cur = new Date(startIso + "T00:00:00");
  while (days.has(isoDay(cur))) {
    streak++;
    cur.setDate(cur.getDate() - 1);
  }
  return streak;
}

/** 今天有记录则从今天起算；今天还没学则保留到昨天为止的连续天数（宽限到当日结束） */
export function streakFromLogs(logs: SessionLog[], todayIso: string): number {
  const days = new Set(logs.map((l) => l.date.slice(0, 10)));
  if (days.has(todayIso)) return countBackward(days, todayIso);
  const yesterday = new Date(todayIso + "T00:00:00");
  yesterday.setDate(yesterday.getDate() - 1);
  return countBackward(days, isoDay(yesterday));
}
